import { useMemo } from 'react';
import { useEventPayload } from '~/hooks/vdp/selectors/useVehicleDetailsForNative';
import useConfirmAfterLogin from './useConfirmAfterLogin';
import useConfirmBeforeLogin from './useConfirmBeforeLogin';
import useLogInAndShowPreOrder from './useLogInAndShowPreOrder';
import useShowPreOrder from './useShowPreOrder';

export default function usePreOrder(): () => void {
  const eventPayload = useEventPayload();
  const showPreOrder = useShowPreOrder();
  const confirmAfterLogin = useConfirmAfterLogin();
  const confirmBeforeLogin = useConfirmBeforeLogin();
  const logInAndShowPreOrder = useLogInAndShowPreOrder(eventPayload);

  return useMemo(
    () =>
      confirmBeforeLogin(
        logInAndShowPreOrder(confirmAfterLogin(showPreOrder), showPreOrder)
      ),
    [confirmAfterLogin, confirmBeforeLogin, logInAndShowPreOrder, showPreOrder]
  );
}
